module.exports = __webpack_public_path__ + "static/media/304.f1cab021.jpg";